var map = {
	"./bayer.png": "862c",
	"./claro.png": "cb47",
	"./galois.png": "1e80",
	"./nextel.png": "9341",
	"./pitney-bowes-brasil.png": "ae9d",
	"./precisely.png": "c927",
	"./santander.png": "2985",
	"./telefonica.png": "347a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef95";